export const CASES_WITH_RECOMMENDED_DETAILS = ['PAMM', 'MBAM', 'BAMM']
export const CASES_WITH_WRONG_TYPE = ['PAMM', 'BAMM', 'PANM', 'BANM' ]